// @flow

import * as React from 'react';

import Box from 'sail/Box';
import {TooltipContainer} from 'sail/Tooltip';
import {Body} from 'sail/Text';

import './ColorBadge.scss';

type ColorBadgeProps = {
  children: React.Node,
  message: ?React.Node,
  position: 'next' | 'end',
};

export const ColorBadge = ({children, message, position}: ColorBadgeProps) => {
  const indicator = (
    <Box className="ColorBadge-separator">
      <Box className="ColorBadge-circle" />
    </Box>
  );

  const tooltip = (
    <TooltipContainer
      contentPadding={4}
      context={indicator}
      position="right"
      tooltipContents={<Body>{message}</Body>}
    />
  );

  const flex =
    position === 'next'
      ? {direction: 'row'}
      : {justifyContent: 'space-between'};

  const result = (
    <Box flex={flex}>
      {children}
      {tooltip}
    </Box>
  );

  return result;
};
